function helperNewDate () {
  return new Date()
}

module.exports = helperNewDate



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/helperNewDate.js
// module id = 214
// module chunks = 75